module.exports = __webpack_public_path__ + "static/staff-4-6f52462fe1a8d5eeba4f3cbcc04a8c25.png";